'use client'
import { ContainerCustomV2, EmptyContent, Icon } from '@/components'
import { formatDateToHours } from '@/utils/date-time'
import StarIcon from '@mui/icons-material/Star'
import {
  Avatar,
  Backdrop,
  Box,
  Card,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Skeleton,
  Stack,
  Typography,
  styled,
} from '@mui/material'
import { AnimatePresence, motion } from 'framer-motion'
import { useTranslations } from 'next-intl'
import { useMemo, useState } from 'react'
import { useInfiniteReviews, useReviewsSumary } from '@/features/products/hooks'
import { RatingCustom } from '../../pages/product-detail/components/rating'
import { IListReviewItem } from '../../types/review'
import { MAX_ITEMS_REVIEW } from '../../utils/constant'
import { ListImagesReview } from './list-images-review'
import PanelPopupFormReview from './panel-popup-form-review'
import { ListTag } from '../../../../components/pages/accounts/content/feedback/feedback-list'
import SidebarReviewFilters from './side-bar-review-filters'

// Component con để hiển thị chi tiết review
interface ReviewCardProps {
  review: IListReviewItem
  index: number
}

const ReviewCard = ({ review, index }: ReviewCardProps) => {
  const t = useTranslations()

  // const getOrderItems = (orderItems: IListReviewItem['order_items']) => {
  //   return orderItems?.map((item) => item?.options?.map((option) => option.value)?.join('-'))
  // }

  const isExistReviewImages = (reviewData: IListReviewItem) => {
    return reviewData?.media && reviewData?.media.length > 0
  }

  return (
    <motion.div
      key={review?.review_id}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10, transition: { duration: 0.2 } }}
      transition={{
        duration: 0.3,
        delay: index * 0.05,
      }}
      // layout
    >
      <StyledCard>
        {/* user info */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Avatar src={review?.author_avatar} sx={{ width: 44, height: 44 }} />
              <Box>
                <Stack direction={'row'} spacing={0.5}>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    color="#3a3a3a"
                    sx={{
                      display: '-webkit-box',
                      WebkitLineClamp: 1,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    {review?.author_name}
                  </Typography>
                  {/* <ListTag
                    tagImage={}
                    sx={{ display: { xs: 'none', sm: 'flex' } }}
                  /> */}
                  {review?.is_verified_buyer && (
                    <PurchasedChip
                      size="small"
                      icon={
                        <Icon.CheckBgWhite
                          sx={{
                            fontSize: { xs: '14px!important', md: '16px!important' },
                            color: '#ffffff!important',
                          }}
                        />
                      }
                      label={t('Đã mua hàng')}
                    />
                  )}
                  {review?.source === 'tiktok' && (
                    <Box
                      sx={{
                        fontSize: '14px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '4px',
                        color: '#fff',
                        backgroundColor: 'primary.main',
                        px: 0.5,
                        borderRadius: '4px',
                      }}
                    >
                      <Icon.TikTok fontSize="inherit" />{' '}
                      <Typography fontSize="inherit">TikTok Shop</Typography>
                    </Box>
                  )}
                  {review?.source === 'shopee' && (
                    <Box
                      sx={{
                        fontSize: '14px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '4px',
                      }}
                    >
                      <Icon.Shopee fontSize="inherit" />
                      <Typography fontSize="inherit">Shopee</Typography>
                    </Box>
                  )}
                </Stack>
                <Stack spacing={0.5} alignItems="center" direction="row">
                  <RatingCustom value={review?.rating || 0} />
                  <Typography fontSize={'12px'} fontWeight={300}>
                    ({review?.rating?.toFixed(1)})
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          </Stack>
        </Box>
        {/* <ListTag tagImage={review?.tag_image} sx={{ display: { xs: 'flex', sm: 'none' } }} /> */}
        <Stack spacing={0.5}>
          {/* <Typography variant="body2" fontWeight={300}>
            {getOrderItems(review?.order_items)?.join(', ')}
          </Typography> */}
          {review?.content && (
            <Typography variant="body2" fontWeight={300}>
              {review?.content}
            </Typography>
          )}

          {/* Hiển thị lý do từ chối nếu có */}
          {/* {review?.admin_response && (
            <Box
              sx={{
                mt: 1,
                p: 1.5,
                bgcolor: '#FFF4E6',
                borderLeft: '3px solid #FF6B6B',
                borderRadius: '4px',
              }}
            >
              <Typography variant="body2" fontWeight={600} color="#D32F2F" mb={0.5}>
                {t('Lý do từ chối')}:
              </Typography>
              <Typography variant="body2" fontWeight={300} color="#D32F2F">
                {review?.admin_response}
              </Typography>
            </Box>
          )} */}
        </Stack>

        {/* image từ list API */}
        {isExistReviewImages(review) && <ListImagesReview media={review?.media} />}

        {/* Chi tiết từ API detail */}
        {review ? (
          <Stack spacing={2.5}>
            {/* Media từ API detail (nếu khác với list API) */}
            {/* Reactions */}
            {review.reactions && review.reactions.length > 0 && (
              <Box>
                <Typography variant="subtitle2" fontWeight={600} mb={1} fontSize="14px">
                  {t('Phản ứng')}
                </Typography>
                <Stack direction="row" spacing={1} flexWrap="wrap" gap={0.5}>
                  {review.reactions.map((reaction) => (
                    <Chip
                      key={reaction.reaction_id}
                      label={`${reaction.reaction} ${reaction.count}`}
                      variant="outlined"
                      size="small"
                      sx={{ fontSize: '12px' }}
                    />
                  ))}
                </Stack>
              </Box>
            )}
            <Stack
              direction={'row'}
              flexWrap={'wrap'}
              gap={1}
              rowGap={{ xs: 0.5, sm: 1 }}
              alignItems={{ xs: 'flex-start', sm: 'center' }}
              sx={{
                // p: { md: '6px 20px', xl: '6px 12px', xs: '0px', sm: '6px 12px' },
                fontSize: '12px',
                // backgroundColor: { xs: 'transparent', sm: '#F0F0F0' },
                // borderRadius: { xs: '4px', sm: '999px' },
                width: { xs: '100%', sm: 'fit-content' },
                fontWeight: 300,
              }}
            >
              {/* {review?.order_created_at && (
            <Fragment>
              <Typography fontSize={'inherit'} fontWeight={'inherit'}>
                {t('Đặt hàng')}:{' '}
                <Typography component={'span'} fontWeight={600}>
                  {formatDateToHours(review?.order_created_at)}
                </Typography>
              </Typography>
              <Divider
                sx={{
                  height: '12px',
                  width: '1px',
                  background: '#BBBBBA',
                  display: { xs: 'none', sm: 'block' },
                }}
              />
            </Fragment>
          )}
          {review?.order_received_at && (
            <Fragment>
              <Typography fontSize={'inherit'} fontWeight={'inherit'}>
                {t('Nhận hàng')}:{' '}
                <Typography component={'span'} fontWeight={600}>
                  {formatDateToHours(review?.order_received_at)}
                </Typography>
              </Typography>
              <Divider
                sx={{
                  height: '12px',
                  width: '1px',
                  background: '#BBBBBA',
                  display: { xs: 'none', sm: 'block' },
                }}
              />
            </Fragment>
          )} */}
              {review?.reviewed_at && (
                <Typography fontSize={'inherit'} fontWeight={'inherit'}>
                  {t('Product.reviews')}:{' '}
                  <Typography component={'span'} variant="body2" fontWeight={600}>
                    {formatDateToHours(review?.reviewed_at)}
                  </Typography>
                </Typography>
              )}
            </Stack>
            {/* Comments */}
            {review.comments && review.comments.length > 0 && (
              <Box>
                <Typography variant="subtitle2" fontWeight={600} mb={1.5} fontSize="14px">
                  {t('Bình luận')} ({review.comments.length})
                </Typography>
                <Stack spacing={1.5}>
                  {review.comments.map((comment) => (
                    <Box key={comment.comment_id}>
                      <Stack
                        spacing={1}
                        sx={{
                          p: 1.5,
                          bgcolor: '#f8f9fa',
                          borderRadius: '8px',
                        }}
                      >
                        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                          <Typography variant="body2" fontWeight={600} fontSize="13px">
                            {comment.author_name}
                          </Typography>
                          <Chip
                            label={comment.author_type}
                            size="small"
                            sx={{
                              height: 18,
                              fontSize: '10px',
                              bgcolor: comment.author_type === 'admin' ? '#e3f2fd' : '#f5f5f5',
                            }}
                          />
                          <Typography variant="caption" color="text.secondary" fontSize="11px">
                            {formatDateToHours(comment.created_at)}
                          </Typography>
                        </Stack>
                        <Typography variant="body2" fontSize="13px" sx={{ whiteSpace: 'pre-wrap' }}>
                          {comment.content}
                        </Typography>
                      </Stack>

                      {/* Replies */}
                      {comment.replies && comment.replies.length > 0 && (
                        <Stack spacing={1} ml={3} mt={1}>
                          {comment.replies.map((reply) => (
                            <Stack
                              key={reply.comment_id}
                              spacing={0.5}
                              sx={{
                                p: 1.5,
                                bgcolor: '#ffffff',
                                border: '1px solid #e0e0e0',
                                borderRadius: '8px',
                              }}
                            >
                              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                                <Typography variant="body2" fontWeight={600} fontSize="12px">
                                  {reply.author_name}
                                </Typography>
                                <Typography variant="caption" color="text.secondary" fontSize="11px">
                                  {formatDateToHours(reply.created_at)}
                                </Typography>
                              </Stack>
                              <Typography variant="body2" fontSize="12px">
                                {reply.content}
                              </Typography>
                            </Stack>
                          ))}
                        </Stack>
                      )}
                    </Box>
                  ))}
                </Stack>
              </Box>
            )}
          </Stack>
        ) : null}
      </StyledCard>
    </motion.div>
  )
}

// Styled components
const StyledCard = styled(Card)(({ theme }) => ({
  // border: `1px solid ${theme.palette.mode === 'dark' ? '#333' : '#bbbbba'}`,
  borderRadius: '24px',
  padding: '24px',
  // marginBottom: '16px',
  boxShadow: 'none',
  backgroundColor: 'white',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  [theme.breakpoints.down('sm')]: {
    gap: '8px',
    padding: '12px',
    borderRadius: '12px',
  },
}))

const PurchasedChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#17b26a',
  color: '#ffffff',
  borderRadius: '4px',
  padding: '2px 4px 2px 2px',
  height: 'unset',

  '& .MuiChip-label': {
    fontSize: '14px',
    paddingRight: '0px',
  },
  [theme.breakpoints.down('md')]: {
    '& .MuiChip-label': {
      fontSize: '12px',
    },
  },
}))
const SourceChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: '#ffffff',
  borderRadius: '4px',
  padding: '2px',
  height: 'unset',
  fontSize: '14px',
}))

interface IReviewListInfiniteProps {
  productId: number
}

export const ReviewListInfinite = ({ productId }: IReviewListInfiniteProps) => {
  const [selectedRating, setSelectedRating] = useState<number | undefined>(undefined)

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isFetching } = useInfiniteReviews({
    // sku: sku,
    productId: productId,
    options: {},
    params: {
      pageSize: MAX_ITEMS_REVIEW * 2,
      rating_stars: selectedRating, // Truyền rating filter vào hook
    },
  })
  const t = useTranslations()
  const [isShowAll, setIsShowAll] = useState<boolean>(false)

  // Lấy thông tin tổng quan từ API riêng (không bị ảnh hưởng bởi filter)
  const { reviewSummary, isLoading: isLoadingSummary } = useReviewsSumary(productId)

  const isLoadingList = isLoading || isLoadingSummary

  const totalRating = reviewSummary?.avg_rating || 0
  const totalReviews = reviewSummary?.total_review || 0

  // Lấy thông tin từ page đầu tiên
  const firstPageData = data?.pages?.[0]

  // Merge tất cả reviews từ các pages
  const allReviews = useMemo(() => {
    if (!data?.pages) return []
    return data.pages.flatMap((page) => page?.items || [])
  }, [data?.pages])

  const handleToggleShowAll = () => {
    if (isShowAll) {
      if (hasNextPage && !isFetchingNextPage) {
        fetchNextPage()
      } else {
        const reviewSection = document.getElementById('review')
        if (reviewSection) {
          reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
        setTimeout(() => {
          setIsShowAll(false)
        }, 300)
      }
    } else {
      // Mở rộng
      if (hasNextPage && !isFetchingNextPage) {
        fetchNextPage()
      }
      setIsShowAll(true)
    }
  }

  // const isExistReviewImages = (review: IListReviewItem) => {
  //   return (review?.images && review?.images.length > 0) || (review?.videos && review?.videos.length > 0)
  // }

  // Hiển thị reviews (nếu chưa mở thì chỉ hiển thị từ firstPageData)
  const displayReviews = isShowAll ? allReviews : (firstPageData?.items || []).slice(0, MAX_ITEMS_REVIEW)
  const bottomText = useMemo(() => {
    if (isShowAll && hasNextPage) return t('Xem thêm')
    return isShowAll ? t('Thu gọn') : t('Tất cả bình luận')
  }, [hasNextPage, isShowAll, t])
  return (
    <Box
      sx={{
        backgroundColor: '#f2f2f2',
        marginBottom: -2,
        py: 4,
        pb: 6,
      }}
      id={'review'}
    >
      <ContainerCustomV2>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={{ xs: 'center', md: 'flex-start' }}
          alignItems={'center'}
          gap={2}
          mb={{ xs: 1, xsm: 2 }}
        >
          <Stack direction={'row'} spacing={1} alignItems="center" fontSize={'1.5rem'}>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Typography fontWeight={600} fontSize="inherit">
                {totalRating === 0 ? '5' : totalRating.toFixed(1)}
              </Typography>
              <StarIcon fontSize="inherit" sx={{ color: '#FEB50D' }} />
            </Stack>
            <Typography
              fontWeight={600}
              fontSize={'inherit'}
              sx={{
                flexGrow: 1,
                opacity: isLoadingList || isFetching ? 0.5 : 1,
                textTransform: 'uppercase',
              }}
            >
              {t('Tất cả đánh giá')} ({totalReviews})
            </Typography>
          </Stack>
          <PanelPopupFormReview productId={productId} />
        </Stack>

        <Grid
          container
          spacing={2}
          sx={{
            flexDirection: {
              xs: 'column-reverse',
              lg: 'row',
            },
          }}
        >
          <Grid size={{ xs: 12, lg: 8 }}>
            <Stack gap={2} sx={{ position: 'relative', height: '100%' }}>
              {/* Loading overlay khi đang filter */}
              {isFetching && !isLoadingList && (
                <Backdrop
                  open
                  sx={{
                    position: 'absolute',
                    zIndex: 5,
                    backgroundColor: 'rgba(242, 242, 242, 0.7)',
                    backdropFilter: 'blur(2px)',
                  }}
                >
                  <CircularProgress size={40} />
                </Backdrop>
              )}

              {/* Skeleton loading khi lần đầu load */}
              {isLoadingList ? (
                <Stack spacing={2} height="100%">
                  <StyledCard>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Skeleton variant="circular" width={44} height={44} />
                      <Box sx={{ flex: 1 }}>
                        <Skeleton variant="text" width="40%" height={24} />
                        <Skeleton variant="text" width="30%" height={20} />
                      </Box>
                    </Stack>
                    <Skeleton variant="text" width="100%" height={20} />
                    <Skeleton variant="text" width="80%" height={20} />
                    <Skeleton variant="rectangular" width="100%" height={150} sx={{ borderRadius: 2 }} />
                  </StyledCard>
                </Stack>
              ) : (
                <>
                  {!displayReviews.length ? (
                    <StyledCard>
                      <Stack alignItems="center" height="100%" gap={2} justifyContent="center">
                        <Typography variant="h6" color="text.secondary">
                          <EmptyContent
                            title="Chưa có đánh giá nào"
                            description="Hãy là người đầu tiên đánh giá sản phẩm này"
                          />
                        </Typography>
                      </Stack>
                    </StyledCard>
                  ) : (
                    <AnimatePresence mode="popLayout">
                      {displayReviews?.map((review, index) => (
                        <ReviewCard key={review.review_id} review={review} index={index} />
                      ))}
                    </AnimatePresence>
                  )}
                </>
              )}

              {/* Action button - Normal position */}
              {hasNextPage && !isLoading && displayReviews.length > 0 && (
                <Stack
                  direction="row"
                  sx={{ cursor: 'pointer' }}
                  onClick={handleToggleShowAll}
                  alignItems="center"
                  justifyContent="center"
                  mt={2}
                  mb={2}
                >
                  <Typography variant="body2" fontWeight={600} color="#3a3a3a">
                    {bottomText}
                  </Typography>
                  <IconButton size="small" color="inherit" disabled={isLoadingList || isFetching}>
                    {isLoadingList || isFetching ? (
                      <Icon.Loading sx={{ width: 16, height: 16 }} />
                    ) : (
                      <Icon.ArrowDown
                        sx={{
                          fontSize: 16,
                          transform: isShowAll && !hasNextPage ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.3s ease',
                        }}
                      />
                    )}
                  </IconButton>
                </Stack>
              )}
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, lg: 4 }}>
            <Box
              sx={{
                position: { xs: 'relative', lg: 'sticky' },
                top: '12px',
                height: 'fit-content',
              }}
            >
              <SidebarReviewFilters
                productId={productId}
                selectedRating={selectedRating}
                onRatingChange={setSelectedRating}
                isLoading={isFetching || isLoadingList}
                totalReviews={totalReviews}
              />
            </Box>
          </Grid>
        </Grid>
      </ContainerCustomV2>
    </Box>
  )
}
